<template>
    <div class="home2_box">
        <div class="top_box">
            <div class="name_box">
                <div class="top_logo">
                    <img
                        class="logo"
                        src="../../static/img/nameIcon.png"
                        alt=""
                    />
                    <div class="names">SNMR-1200调度平台</div>
                </div>
                <div class="top_nav">
                    <div
                        class="nav_sin"
                        v-for="(item, index) of navList"
                        :key="index"
                    >
                        <div
                            :class="
                                nowUrl == item.url
                                    ? 'sin_box nav_sinact'
                                    : 'sin_box'
                            "
                            @click="to_nav(item.url)"
                        >
                            {{ item.name }}
                        </div>
                        <div
                            class="sin_divide"
                            v-if="index !== navList.length - 1"
                        ></div>
                    </div>
                    <div class="sys_box">
                        <el-select
                            v-model="sys_code"
                            placeholder="请选择"
                            size="mini"
                        >
                            <el-option
                                v-for="item in xtArr"
                                :key="item.sys_code"
                                :label="item.sys_name"
                                :value="item.sys_code"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="back">
                        <el-dropdown>
                            <span class="el-dropdown-link">
                                <el-avatar
                                    size="small"
                                    src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                                ></el-avatar>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    @click.native="backBtn"
                                    v-if="user_type == '1'"
                                    >返回导航</el-dropdown-item
                                >
                                <el-dropdown-item @click.native="pwdBtn">修改密码</el-dropdown-item>
                                <el-dropdown-item
                                    style="color: #f56c6c"
                                    @click.native="outBtn"
                                    >退出</el-dropdown-item
                                >
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_box">
            <router-view :sys_code="sys_code"></router-view>
        </div>
        <!-- 修改密码 -->
        <Setpwd ref="pwdRef"></Setpwd>
    </div>
</template>

<script>
import { frequency } from "@/api/subpage";
export default {
    name: "Home2",
    data() {
        return {
            nowUrl: "",
            navList: [
                {
                    name: "语音调度",
                    url: "/homeDd/yydd",
                },
                {
                    name: "定位地图",
                    url: "/homeDd/dwdt",
                },
                {
                    name: "录音查询",
                    url: "/homeDd/lycx",
                },
                // {
                //     name: "视频调度",
                //     url: "/homeDd/spdd",
                // },
                {
                    name: "系统授权",
                    url: "/homeDd/xtsq",
                },
            ],
            user_type: this.$cookie.get("userType"),
            xtArr: [],
            sys_code: "",
        };
    },
    watch: {
        $route: {
            handler(to, from) {
                this.nowUrl = to.path;
            },
            immediate: true,
        },
    },
    components: {
        Setpwd: () => import("@/components/common/setpwd"),
    },
    computed: {},
    mounted() {
        this.getFrequency();
    },
    methods: {
        // 获取系统
        getFrequency() {
            frequency().then((res) => {
                let { data, errorNo } = res;
                if (errorNo == 0) {
                    this.xtArr = data;
                    this.sys_code = data[0].sys_code;
                } else {
                    this.xtArr = [];
                    this.sys_code = "";
                }
            });
        },
        // 跳转页面
        to_nav(val) {
            this.$router.push(val);
        },
        // 返回导航
        backBtn() {
            this.$router.push("/nav");
        },
        // 修改密码
        pwdBtn() {
            this.$refs.pwdRef.pwdSet()
        },
        // 退出登录
        outBtn() {
            this.$confirm("此操作将退出登录, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$router.push("/login");
                    this.$message({
                        type: "success",
                        message: "退出成功!",
                    });
                    this.$cookies.remove("token");
                    this.$cookies.remove("menuNum");
                })
                .catch(() => {});
        },
    },
};
</script>
<style lang='less' scoped>
.home2_box {
    width: 100%;
    height: 100%;
    .top_box {
        width: 100%;
        height: 3.3rem;
        background: #152a3d;
        .name_box {
            width: 100%;
            height: 100%;
            background: url("../assets/images/home2/top_bg.png") center center
                no-repeat;
            background-size: 100% 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            .top_logo {
                width: 30rem;
                height: 100%;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                .logo {
                    width: 3.5rem;
                    height: 1.65rem;
                    margin-right: 1rem;
                }
                .names {
                    font-family: YouSheBiaoTiHei;
                    font-size: 1.4rem;
                    color: #ffffff;
                }
            }
            .top_nav {
                width: calc(100% - 37rem);
                height: 100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                padding-bottom: 0.6rem;
                box-sizing: border-box;
                position: relative;
                .nav_sin {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    .sin_box {
                        width: 4.9rem;
                        height: 1.5rem;
                        background: url("../assets/images/home2/nav_sin.png")
                            center center no-repeat;
                        background-size: 100% 100%;
                        font-size: 0.6rem;
                        color: #fff;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        padding-bottom: 0.3rem;
                        box-sizing: border-box;
                        cursor: pointer;
                        user-select: none;
                    }
                    .nav_sinact {
                        background: url("../assets/images/home2/nav_sinact.png")
                            center center no-repeat;
                        background-size: 100% 100%;
                    }
                    .sin_divide {
                        width: 0.55rem;
                        height: 1.25rem;
                        background: url("../assets/images/home2/nav_divide.png")
                            center center no-repeat;
                        background-size: 100% 100%;
                        margin: 0 0.35rem;
                    }
                }
                .sys_box {
                    width: 7rem;
                    position: absolute;
                    top: 0.6rem;
                    right: 3.5rem;
                    /deep/ .el-input__inner {
                        background-color: #294062;
                        border: 1px solid #294062;
                        color: #fff;
                    }
                    /deep/ .el-range-editor--medium .el-range-input {
                        background-color: #294062;
                        color: #fff;
                    }
                    /deep/ .el-range-editor--medium .el-range-separator {
                        color: #c0c4cc;
                    }
                }
                .back {
                    cursor: pointer;
                    height: 100%;
                    padding-bottom: 0.6rem;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    position: absolute;
                    top: 0rem;
                    right: 1rem;
                }
            }
        }
    }

    .main_box {
        width: 100%;
        height: calc(100% - 3.3rem);
        background: #152a3d;
    }
}
</style>